var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.$root.isMobileOnly && !_vm.item.driverBreakId
    ? _c(
        "div",
        { staticClass: "custom-button-container" },
        [
          _vm.type === "text" && !_vm.isSingleUser && !_vm.isSingleTeamMember
            ? _c(
                "span",
                {
                  class: "value custom-a-blue " + _vm.className,
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                      return _vm.handleAssignStop({
                        stopId: _vm.item.stopId,
                        assignedTo:
                          _vm.item.assignedTo !== null
                            ? _vm.item.assignedTo.publicUserId
                            : "",
                        assignedCarrierTeamId: _vm.item.carrierTeamId,
                        stopRef: _vm.item.stopRef,
                        teamRegionId: _vm.item.teamRegionId,
                        displayAvailabilityIndicator:
                          _vm.displayAvailabilityIndicator,
                      })
                    },
                  },
                },
                [
                  _vm.item.assignedTo !== null &&
                  Boolean(_vm.item.assignedTo.publicUserId)
                    ? _c(
                        "a",
                        {
                          staticClass: "custom-ellipsis",
                          attrs: { href: "#", title: "reassign stop" },
                        },
                        [
                          _vm.item.assignedTo.fullName
                            ? _c("img", {
                                staticClass: "profile-image",
                                attrs: {
                                  src:
                                    _vm.item.assignedTo.photoUrl !== null
                                      ? _vm.item.assignedTo.photoUrl
                                      : _vm.$root.defaultPhotoUrl,
                                  alt: "avatar",
                                },
                                on: { error: _vm.$_setDefaultBrokenImage },
                              })
                            : _vm._e(),
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.item.assignedTo.fullName) +
                              "\n            "
                          ),
                          _vm.item.assignedTo.memberCode
                            ? _c(
                                "span",
                                {
                                  directives: [
                                    {
                                      name: "feature",
                                      rawName: "v-feature",
                                      value:
                                        _vm.FEATURE_NAMES.MemberCodeDisplay,
                                      expression:
                                        "FEATURE_NAMES.MemberCodeDisplay",
                                    },
                                  ],
                                  staticClass: "member-code",
                                },
                                [
                                  _vm._v(
                                    "\n                (" +
                                      _vm._s(_vm.item.assignedTo.memberCode) +
                                      ")\n            "
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ]
                      )
                    : _vm.item.carrierTeamId
                    ? _c(
                        "a",
                        {
                          staticClass: "custom-ellipsis",
                          attrs: { href: "#", title: "reassign stop" },
                        },
                        [
                          _vm.item.carrierTeam
                            ? _c("img", {
                                staticClass: "profile-image",
                                attrs: {
                                  src:
                                    _vm.item.carrierTeam.logoUrl !== null
                                      ? _vm.item.carrierTeam.logoUrl
                                      : _vm.$root.defaultLogoUrl,
                                  alt: "carrier logo",
                                },
                                on: { error: _vm.$_setDefaultBrokenImage },
                              })
                            : _vm._e(),
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.item.carrierTeam.company) +
                              "\n        "
                          ),
                        ]
                      )
                    : _c(
                        "a",
                        { attrs: { href: "#", title: "reassign stop" } },
                        [_vm._v("Unassigned")]
                      ),
                ]
              )
            : _vm._e(),
          _vm.type === "text" && (_vm.isSingleUser || _vm.isSingleTeamMember)
            ? _c("span", { class: "custom-ellipsis value " + _vm.className }, [
                _vm.item.assignedTo.fullName
                  ? _c("img", {
                      staticClass: "profile-image",
                      attrs: {
                        src:
                          _vm.item.assignedTo.photoUrl !== null
                            ? _vm.item.assignedTo.photoUrl
                            : _vm.$root.defaultPhotoUrl,
                        alt: "avatar",
                      },
                      on: { error: _vm.$_setDefaultBrokenImage },
                    })
                  : _vm._e(),
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.item.assignedTo.fullName) +
                    "\n        "
                ),
                _vm.item.assignedTo.memberCode
                  ? _c(
                      "span",
                      {
                        directives: [
                          {
                            name: "feature",
                            rawName: "v-feature",
                            value: _vm.FEATURE_NAMES.MemberCodeDisplay,
                            expression: "FEATURE_NAMES.MemberCodeDisplay",
                          },
                        ],
                        staticClass: "member-code",
                      },
                      [
                        _vm._v(
                          "\n            (" +
                            _vm._s(_vm.item.assignedTo.memberCode) +
                            ")\n        "
                        ),
                      ]
                    )
                  : _vm._e(),
              ])
            : _vm._e(),
          _vm.type === "icon" && !_vm.isSupportStaff
            ? _c(
                "md-button",
                {
                  class: "md-info md-just-icon md-round " + _vm.className,
                  attrs: {
                    title: "Re-assign driver",
                    "data-testid": "reassign-stop",
                  },
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                      return _vm.handleAssignStop({
                        stopId: _vm.item.stopId,
                        assignedTo:
                          _vm.item.assignedTo !== null
                            ? _vm.item.assignedTo.publicUserId
                            : "",
                        assignedCarrierTeamId: _vm.item.carrierTeamId,
                        stopRef: _vm.item.stopRef,
                        teamRegionId: _vm.item.teamRegionId,
                        displayAvailabilityIndicator:
                          _vm.displayAvailabilityIndicator,
                      })
                    },
                  },
                },
                [_c("md-icon", [_vm._v("person_pin")])],
                1
              )
            : _vm._e(),
          _vm.type === "button" && !_vm.isCustomer && !_vm.isSupportStaff
            ? _c(
                "md-button",
                {
                  class: "custom-btn " + _vm.className,
                  attrs: {
                    title: "Re-assign driver",
                    "data-testid": "reassign-stop",
                  },
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                      return _vm.handleAssignStop({
                        stopId: _vm.item.stopId,
                        assignedTo:
                          _vm.item.assignedTo !== null
                            ? _vm.item.assignedTo.publicUserId
                            : "",
                        assignedCarrierTeamId: _vm.item.carrierTeamId,
                        stopRef: _vm.item.stopRef,
                        teamRegionId: _vm.item.teamRegionId,
                        displayAvailabilityIndicator:
                          _vm.displayAvailabilityIndicator,
                      })
                    },
                  },
                },
                [_vm._v("\n        Assign\n    ")]
              )
            : _vm._e(),
        ],
        1
      )
    : _c(
        "div",
        {
          staticClass: "reassign-btn-mobile",
          attrs: { "data-testid": "reassign-stop" },
          on: {
            click: function ($event) {
              $event.stopPropagation()
              return _vm.handleAssignStop({
                stopId: _vm.item.stopId,
                assignedTo:
                  _vm.item.assignedTo !== null &&
                  _vm.item.assignedTo.publicUserId !== null
                    ? _vm.item.assignedTo.publicUserId
                    : null,
                assignedCarrierTeamId: _vm.item.carrierTeamId,
                stopRef: _vm.item.stopRef,
                teamRegionId: _vm.item.teamRegionId,
              })
            },
          },
        },
        [
          !_vm.item.driverBreakId
            ? _c("div", { staticClass: "action-button" }, [
                _vm.item.assignedTo !== null && _vm.item.assignedTo.fullName
                  ? _c("span", [_vm._v("Reallocate")])
                  : _c("span", [_vm._v("Allocate")]),
              ])
            : _vm._e(),
        ]
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }